import React, { useContext, Fragment } from "react";
import { Container, Segment, Header, Button, Image } from "semantic-ui-react";
import { RootStoreContext } from "../../app/stores/rootStore";
import LoginForm from "../user/LoginForm";

const HomePage = () => {
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;
  return (
    <Segment inverted textAlign="center" vertical className="masthead">
      <Container text>
        <Header as="h1" inverted>
          <Image
            src="/assets/logo.png"
            alt="logo"
            style={{ marginBottom: 12 }}
          />
          <br />
          Warranty Registration System
        </Header>
        <Fragment>
          <Button onClick={() => openModal(<LoginForm />)} size="huge" inverted>
            Login
          </Button>
        </Fragment>
        {/* )} */}
      </Container>
    </Segment>
  );
};

export default HomePage;
